!((document, Drupal) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.header = {
    attach: function (context) {
      const menuToggle = document.querySelector(
        '.l-header__controls-menu',
        context
      );
      const menuText = menuToggle.querySelector('.title');
      const mobileMenu = document.querySelector('.l-header__mobile-menu');

      menuToggle.addEventListener('click', function () {
        if (menuToggle.classList.contains('l-header__controls-menu--active')) {
          menuText.textContent = 'Open Menu';
          mobileMenu.classList.remove('l-header__mobile-menu--active');
          menuToggle.setAttribute('aria-expanded', false);
          menuToggle.classList.remove('l-header__controls-menu--active');
        }
        else {
          menuText.textContent = 'Close Menu';
          mobileMenu.classList.add('l-header__mobile-menu--active');
          menuToggle.setAttribute('aria-expanded', true);
          menuToggle.classList.add('l-header__controls-menu--active');
        }
      });

      const desktopSearch = document.querySelector(
        '.l-header__desktop .l-header__search',
        context
      );
      const desktopSearchInput = document.querySelector(
        '.l-header__desktop .l-header__search .form-item__text',
        context
      );
      const desktopSearchClose = document.querySelector(
        '.l-header__desktop .l-header__search .l-header__search--toggle',
        context
      );
      desktopSearchInput.addEventListener('focus', function () {
        desktopSearch.classList.add('is-focused');
      });
      desktopSearchClose.addEventListener('click', function () {
        desktopSearch.classList.remove('is-focused');
      });

      const searchToggle = document.querySelector(
        '.l-header__controls-search',
        context
      );
      const mobileSearch = document.querySelector('.l-header__mobile-search');

      searchToggle.addEventListener('click', function () {
        if (
          searchToggle.classList.contains('l-header__controls-search--active')
        ) {
          mobileSearch.classList.remove('l-header__mobile-search--active');
          searchToggle.setAttribute('aria-expanded', false);
          searchToggle.classList.remove('l-header__controls-search--active');
        }
        else {
          mobileSearch.classList.add('l-header__mobile-search--active');
          searchToggle.setAttribute('aria-expanded', true);
          searchToggle.classList.add('l-header__controls-search--active');
        }
      });

      var s1 = new autoComplete({
        selector: '.l-header__desktop .hunterdon-search-form .form-item__text',
        menuClass: 'autocomplete',
        minChars: 4,
        delay: 250,
        source: function source(term, response) {
          $.getJSON('/search/suggest', {
            keys: term
          }, function (data) {
            response(data);
          });
        },
        renderItem: function renderItem(item, search) {
          var url = item.url;
          item = item.title;
          search = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
          var re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
          return '<div class="autocomplete-suggestion" data-url="' + url + '" data-val="' + item + '">' + item.replace(re, '<b>$1</b>') + '</div>';
        },
        onSelect: function onSelect(event, term, item) {
          window.location = item.getAttribute('data-url');
        }
      });


      var s2 = new autoComplete({
        selector: '.l-header__mobile .hunterdon-search-form .form-item__text',
        menuClass: 'autocomplete',
        minChars: 4,
        delay: 250,
        source: function source(term, response) {
          $.getJSON('/search/suggest', {
            keys: term
          }, function (data) {
            response(data);
          });
        },
        renderItem: function renderItem(item, search) {
          var url = item.url;
          item = item.title;
          search = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
          var re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
          return '<div class="autocomplete-suggestion" data-url="' + url + '" data-val="' + item + '">' + item.replace(re, '<b>$1</b>') + '</div>';
        },
        onSelect: function onSelect(event, term, item) {
          window.location = item.getAttribute('data-url');
        }
      });


    }
  };
})(document, Drupal);
